import { TaskType } from '@navio/nsdk';
import type { NoddiIconName } from 'noddi-ui-common';

export const TASK_TYPE_ICON: Record<TaskType, NoddiIconName> = {
  [TaskType.CAR_TIRE_PHOTO_DOCUMENTATION]: 'Camera',
  [TaskType.CAR_TIRE_SIZE_REGISTRATION]: 'Ruler',
  [TaskType.CAR_TIRE_TREAD_DEPTH_MEASUREMENT]: 'ScanLine',
  [TaskType.CUSTOM]: 'WandSparkles',
  [TaskType.SERVICE]: 'Wrench'
};
